import cn from 'classnames';
import { stickyShadowStyles } from '@lp/features/Scheduler/constants';
import { getSortIcon } from '@/utils/helpers';

type UserProfileHeaderProps = {
  sortAsc?: boolean;
  toggleSortAsc: () => void;
};

export const UserProfileHeader = ({ sortAsc, toggleSortAsc }: UserProfileHeaderProps) => {
  return (
    <th key="user" className={cn('bg-base-70 text-base-20 sticky min-w-[220px] left-0 z-11', stickyShadowStyles)}>
      <div className="flex items-center gap-2">
        <span className="uppercase">Specialist</span>
        <button
          className={cn(sortAsc === undefined ? 'text-base-30' : 'text-base-20', 'hover:text-base-20')}
          onClick={toggleSortAsc}
        >
          {getSortIcon(sortAsc)}
        </button>
      </div>
    </th>
  );
};
